import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { NotificationTypeEnum } from 'Components/designSystem';
import i18n from 'i18next';

import { fetchAvailableTenantsThunk, fetchUserThunk, getUserAuthInfo, setError, setStatus } from './authSlice';

const authMiddleware = createListenerMiddleware();
const ERROR_DURATION = 5000;

authMiddleware.startListening({
    matcher: isAnyOf(setError,
        fetchUserThunk.rejected,
        fetchAvailableTenantsThunk.rejected,
        getUserAuthInfo.rejected,
    ),
    effect: async (action, listenerAPI) => {
        let errorMessage = '';
        
        switch (action.type) {
            case setError.type:
                errorMessage = (action as any).payload.errorMessage;
                break;
            case fetchUserThunk.rejected.type:
                errorMessage = i18n.t('userFetchError', { ns: 'auth' });
                break;
            case fetchAvailableTenantsThunk.rejected.type:
                errorMessage = i18n.t('tenantFetchError', { ns: 'auth' });
                break;
            case getUserAuthInfo.rejected.type:
                errorMessage = i18n.t('tokenHintFetchError', { ns: 'auth' });
                break;
            default:
                errorMessage = i18n.t('loginError', { ns: 'auth' });
        }

        import('modules/ToastManager').then(({ showToast }) => {
            listenerAPI.dispatch(showToast({
                toast: {
                    id: 'authError',
                    type: NotificationTypeEnum.Error,
                    description: errorMessage,
                    duration: ERROR_DURATION
                }
            }));
        });
    }
});

authMiddleware.startListening({
    actionCreator: getUserAuthInfo.rejected,
    effect: async (action, listenerAPI) => {
        listenerAPI.dispatch(setStatus('unauthorized'));
    }
});

export default authMiddleware;
